import { render, staticRenderFns } from "./client-modals.vue?vue&type=template&id=59fe3a45"
import script from "./client-modals.vue?vue&type=script&lang=js"
export * from "./client-modals.vue?vue&type=script&lang=js"
import style0 from "./client-modals.vue?vue&type=style&index=0&id=59fe3a45&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports